import { EMAIL_ADDRESS_TYPE } from "@/static/emailAddressTypes";
import { RELATED_EMAIL_TYPE } from "@/static/relatedEmailTypes";
import { SELECTED_EMAIL_TYPE } from "@/static/selectedEmailTypeEnum";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString } from "class-validator";

export class AddEditEmailAddress {
  @Expose()
  @IsOptional()
  @IsString()
  mail!: string | null;

  @Expose()
  @IsOptional()
  @IsString()
  comment!: string | null;

  @Expose()
  @IsBoolean()
  isDefault!: boolean;

  @Expose()
  @IsEnum(EMAIL_ADDRESS_TYPE)
  emailAddressType!: EMAIL_ADDRESS_TYPE;

  @Expose()
  @IsEnum(RELATED_EMAIL_TYPE)
  relatedEmailType!: RELATED_EMAIL_TYPE;

  @Expose()
  @IsOptional()
  @IsNumber()
  attributePrototypeId!: number | null;

  selectedEmailType!: SELECTED_EMAIL_TYPE;

  clearNotUsedAddress() {
    if (this.selectedEmailType == SELECTED_EMAIL_TYPE.AttributeValue) this.mail = null;
    else this.attributePrototypeId = null;
  }

  constructor() {
    this.emailAddressType = EMAIL_ADDRESS_TYPE.To;
    this.relatedEmailType = RELATED_EMAIL_TYPE.Invoice;
    this.selectedEmailType = SELECTED_EMAIL_TYPE.SpecificAddress;
  }
}

export class EmailAddress extends AddEditEmailAddress {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsNumber()
  recordStampId!: number;

  constructor() {
    super();
  }
}
